var _rect, _path, _rect2, _mask, _path2, _rect3, _g, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignmentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Assign License"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1400 -364C-1400 -365.105 -1399.1 -366 -1398 -366H219C220.105 -366 221 -365.105 221 -364V3510C221 3511.1 220.105 3512 219 3512H-1398C-1399.1 3512 -1400 3511.1 -1400 3510V-364Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "List Assigned Licenses"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 768,
    transform: "translate(-1302 -238)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 319"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_137_349",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22 -6H98V26H-22V-6Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-22 -6H98V26H-22V-6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "assignment_add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_137_349",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_137_349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "assignment_add_2",
    d: "M4.16667 17.5002C3.70833 17.5002 3.31597 17.337 2.98958 17.0106C2.66319 16.6842 2.5 16.2918 2.5 15.8335V4.16683C2.5 3.7085 2.66319 3.31614 2.98958 2.98975C3.31597 2.66336 3.70833 2.50016 4.16667 2.50016H7.66667C7.84722 2.00016 8.14931 1.59739 8.57292 1.29183C8.99653 0.986274 9.47222 0.833496 10 0.833496C10.5278 0.833496 11.0035 0.986274 11.4271 1.29183C11.8507 1.59739 12.1528 2.00016 12.3333 2.50016H15.8333C16.2917 2.50016 16.684 2.66336 17.0104 2.98975C17.3368 3.31614 17.5 3.7085 17.5 4.16683V9.75016C17.2361 9.62516 16.9653 9.51752 16.6875 9.42725C16.4097 9.33697 16.125 9.271 15.8333 9.22933V4.16683H4.16667V15.8335H9.20833C9.25 16.1391 9.31597 16.4307 9.40625 16.7085C9.49653 16.9863 9.60417 17.2502 9.72917 17.5002H4.16667ZM4.16667 15.8335V4.16683V9.22933V9.16683V15.8335ZM5.83333 14.1668H9.22917C9.27083 13.8752 9.33681 13.5904 9.42708 13.3127C9.51736 13.0349 9.61806 12.7641 9.72917 12.5002H5.83333V14.1668ZM5.83333 10.8335H10.9167C11.3611 10.4168 11.8576 10.0696 12.4062 9.79183C12.9549 9.51405 13.5417 9.32655 14.1667 9.22933V9.16683H5.83333V10.8335ZM5.83333 7.50016H14.1667V5.8335H5.83333V7.50016ZM10 3.54183C10.1806 3.54183 10.3299 3.4828 10.4479 3.36475C10.566 3.24669 10.625 3.09739 10.625 2.91683C10.625 2.73627 10.566 2.58697 10.4479 2.46891C10.3299 2.35086 10.1806 2.29183 10 2.29183C9.81944 2.29183 9.67014 2.35086 9.55208 2.46891C9.43403 2.58697 9.375 2.73627 9.375 2.91683C9.375 3.09739 9.43403 3.24669 9.55208 3.36475C9.67014 3.4828 9.81944 3.54183 10 3.54183ZM15 19.1668C13.8472 19.1668 12.8646 18.7606 12.0521 17.9481C11.2396 17.1356 10.8333 16.1529 10.8333 15.0002C10.8333 13.8474 11.2396 12.8647 12.0521 12.0522C12.8646 11.2397 13.8472 10.8335 15 10.8335C16.1528 10.8335 17.1354 11.2397 17.9479 12.0522C18.7604 12.8647 19.1667 13.8474 19.1667 15.0002C19.1667 16.1529 18.7604 17.1356 17.9479 17.9481C17.1354 18.7606 16.1528 19.1668 15 19.1668ZM14.5833 17.5002H15.4167V15.4168H17.5V14.5835H15.4167V12.5002H14.5833V14.5835H12.5V15.4168H14.5833V17.5002Z",
    fill: "#1C1B1F"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98 -6H99V-7H98V-6ZM98 26V27H99V26H98ZM-22 -5H98V-7H-22V-5ZM97 -6V26H99V-6H97ZM98 25H-22V27H98V25Z",
    fill: "#B6B6B6",
    mask: "url(#path-3-inside-1_137_349)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1398 -365H219V-367H-1398V-365ZM220 -364V3510H222V-364H220ZM219 3511H-1398V3513H219V3511ZM-1399 3510V-364H-1401V3510H-1399ZM-1398 3511C-1398.55 3511 -1399 3510.55 -1399 3510H-1401C-1401 3511.66 -1399.66 3513 -1398 3513V3511ZM220 3510C220 3510.55 219.552 3511 219 3511V3513C220.657 3513 222 3511.66 222 3510H220ZM219 -365C219.552 -365 220 -364.552 220 -364H222C222 -365.657 220.657 -367 219 -367V-365ZM-1398 -367C-1399.66 -367 -1401 -365.657 -1401 -364H-1399C-1399 -364.552 -1398.55 -365 -1398 -365V-367Z",
    fill: "black",
    fillOpacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentAdd);
export default __webpack_public_path__ + "static/media/assignment_add.5911e485825c1061125c5e424939528b.svg";
export { ForwardRef as ReactComponent };